import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customTitleCase',
  standalone: true,
})
export class CustomTitleCasePipe implements PipeTransform {
  constructor(private titleCasePipe: TitleCasePipe) {}

  transform(value: string): string {
    if (!value) return value;
    const withoutUnderscore = value.replace(/_/g, ' ');
    return this.titleCasePipe.transform(withoutUnderscore);
  }
}
